/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dropzone{-webkit-box-align:center;align-items:center;background-color:var(--background-primary)!important;color:var(--foreground-primary)!important;border:3px dotted grey;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.dropzone:active{background:red!important;border:none!important}.dropzone:drop{background:red!important;border:none!important}.dropzone:dragleave{background:var(--background-primary)!important;color:var(--foreground-primary)!important;border:3px dotted grey}"];
export { styles as styles };
